import React from 'react';

import JobsListPage from '../../../js/pages/JobsListPage';
import dataEngineer from '../../../js/pages/JobsListPage/dataEngineerJobs';

const Page = () => <JobsListPage role={dataEngineer} />;

export default Page;
